// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// RemoveAwardFromProgramModificationProgramHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import ProgramModificationChangeRequestDTO from '../models/ProgramModificationChangeRequestDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    programModificationChangeRequest: ProgramModificationChangeRequestDTO | null;
    awardId: string | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            programModificationChangeRequest: null,
            awardId: '00000000-0000-0000-0000-000000000000',
        },
        initValues);
    },
    programModificationChangeRequest: 'programModificationChangeRequest',
    awardId: 'awardId',
}

interface Result extends ResultDTO {
    programModificationChangeRequest: ProgramModificationChangeRequestDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            programModificationChangeRequest: null,
        },
        initValues);
    },
    programModificationChangeRequest: 'programModificationChangeRequest',
}

export { Request, Result };